export const credentialStatus = {
  valid: {
    label: 'Valid',
    connectionLabel: 'Connected',
    tone: 'success',
    description: 'The credential is active and ready for use.',
    color: '#5cb15c',
    textColor: '#29925F',
    backgroundColor: '#EEF6F2'
  },
  expired: {
    label: 'Expired',
    connectionLabel: 'Expired',
    tone: 'danger',
    description: 'The credential has passed its expiration date and cannot be used.',
    color: '#d48b8b',
    textColor: '#F04438',
    backgroundColor: '#FEEFEE'
  },
  revoked: {
    label: 'Revoked',
    connectionLabel: 'Revoked',
    tone: 'danger',
    description: 'The credential has been manually revoked and is no longer valid.',
    color: '#d48b8b',
    textColor: '#F04438',
    backgroundColor: '#FEEFEE'
  },
  invalid: {
    label: 'Invalid',
    connectionLabel: 'Invalid',
    tone: 'danger',
    description: 'The credential is not valid, possibly due to incorrect data or format.',
    color: '#d48b8b',
    textColor: '#F04438',
    backgroundColor: '#FEEFEE'
  },
  incomplete: {
    label: 'Incomplete',
    connectionLabel: 'Incomplete',
    tone: 'warning',
    description: 'The credential setup is incomplete and requires additional information.',
    color: '#dbdbdb',
    textColor: '#697586',
    backgroundColor: '#F8F8F8'
  },
  unsupported: {
    label: 'Unsupported',
    connectionLabel: 'Unsupported',
    tone: 'warning',
    description: 'The App does not yet support credential testing.',
    color: '#dbdbdb',
    textColor: '#697586',
    backgroundColor: '#F8F8F8'
  },
  unknown: {
    label: 'Untested',
    connectionLabel: 'Pending',
    tone: 'neutral',
    description: 'The connection has not been tested yet or its validity is unknown.',
    color: '#dbdbdb',
    textColor: '#697586',
    backgroundColor: '#F8F8F8'
  }
};

export const getCredentialConnectionStatusPresentation = (status) => {
  const statusKey = status || 'unknown';
  const statusSchema = credentialStatus[statusKey];

  if (!statusSchema) {
    throw new Error(`Unsupported credential status "${statusKey}". Expected one of: ${Object.keys(credentialStatus).join(', ')}`);
  }

  return {
    label: statusSchema.connectionLabel,
    tone: statusSchema.tone
  };
};
